import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { QcEventFilters, QcEventListPage, QcRecord } from '../domain/qc.model';

@Injectable({
  providedIn: 'root'
})
export class QcService {
  private readonly baseUrl = environment.API_HOST + '/api/qc';

  constructor(private http: HttpClient) {}

  listEvents(filters: QcEventFilters): Observable<QcEventListPage> {
    let params = new HttpParams()
      .set('page', filters.page)
      .set('pageSize', filters.pageSize)
      .set('showAnalyzed', String(filters.showAnalyzed));
    if (filters.league?.trim()) {
      params = params.set('league', filters.league.trim());
    }
    if (filters.eventCode?.trim()) {
      params = params.set('eventCode', filters.eventCode.trim());
    }
    if (filters.game?.trim()) {
      params = params.set('game', filters.game.trim());
    }
    if (filters.collectorAuthId?.trim()) {
      params = params.set('collectorAuthId', filters.collectorAuthId.trim());
    }
    if (filters.dcDateFrom?.trim()) {
      params = params.set('dcDateFrom', filters.dcDateFrom.trim());
    }
    if (filters.dcDateTo?.trim()) {
      params = params.set('dcDateTo', filters.dcDateTo.trim());
    }

    return this.http.get<QcEventListPage>(this.baseUrl, { params });
  }

  updateQcData(eventId: string, qc: QcRecord): Observable<{ qc: QcRecord }> {
    return this.http.patch<{ qc: QcRecord }>(`${this.baseUrl}/${eventId}`, qc);
  }
}
